import React, {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

import * as constants from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import InputSideCustom from 'views/pages/components/InputSideCustom';
import {InputArraySideSelect,} from 'views/pages/components/InputSelect';

import {Button, Card, CardBody, CardHeader, Col, Container, Row,} from 'reactstrap';
import notify from '@utils/notify';

export default function Profit() {

  const [token, setToken] = useState('');
  const [dealers, setDealers] = useState([]);
  const [filter, setFilter] = useState('');
  const [items, setItems] = useState('');

  const fetchData = async (source, token, filter) => {
    try {
      const response = await axios({
        method: 'GET',
        url: constants.API_URL + '/report/vehicles/profit',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: filter,
        cancelToken: source.token,
      })
      console.log('response :: ', response.data)
      const data = response.data
      setDealers(data.data.dealers)
      setFilter({
        ...data.data.filter,
        from: data.data.filter.from? constants.formatDate(data.data.filter.from) : '',
        to: data.data.filter.to? constants.formatDate(data.data.filter.to) : '',
      })
      setItems(data.data.items)
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request canceled :: ', error)
      } else {
        console.error('error :: ', error)
        notify.warning(error.response ? error.response.statusText : 'Error occurred!')
      }
    }
  }

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()
    fetchData(source, grs_token, '')

    return () => {
      source.cancel()
    };
  }, [])


  const filterItems = () => {
    const source = axios.CancelToken.source()
    fetchData(source, token, {
      ...filter,
      from: constants.formatDate(filter.from),
      to: constants.formatDate(filter.to),
    })
  }

  const resetItems = () => {
    const source = axios.CancelToken.source()
    fetchData(source, token, '')
  }

  return (
    <>
      <CardsHeader name="Vehicle Cost Profit" parentName="Home" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <h1 className="title">Sales</h1>
                <p className="text-sm mb-0">Sales overview</p>
              </CardHeader>
              <CardBody>
                <Container>
                  <Row>
                    <Col md={6} sm={12}>
                      <InputSideCustom 
                        type={`date`}
                        label={`From`}
                        value={filter && filter.from? filter.from: ''}
                        onChange={e => setFilter({
                          ...filter,
                          from: e.target.value
                        })}
                      />
                    </Col>
                    <Col md={6} sm={12}>
                      <InputSideCustom 
                        type={`date`}
                        label={`To`}
                        value={filter && filter.to? filter.to: ''}
                        onChange={e => setFilter({
                          ...filter,
                          to: e.target.value
                        })}
                      />
                    </Col>
                    {filter.isAllowedToFilterByDealer && 
                    <Col md={6} sm={12}>
                      <InputArraySideSelect
                        label={`Offices`}
                        options={dealers}
                        value={filter && filter.office? filter.office: ''}
                        onChange={e => setFilter({
                          ...filter,
                          office: e.target.value
                        })}
                        valueKey={`id`}
                        labelKey={`name`}
                        defaultOption={true}
                      />
                    </Col>}
                  </Row>
                  <div className="d-flex flex-row justify-content-center">
                    <Button className="w-50" color="success" onClick={() => filterItems()}>Filter</Button>
                    <Button className="w-50" color="danger" onClick={() => resetItems()}>Reset</Button>
                  </div>
                </Container>
                <Row className="mt-4">
                  <Col xl={12} className="px-5">
                    <div className="d-flex flex-row justify-content-sm-around flex-wrap">
                      <div className="p-2">
                        <h2 className="mb-0">{`Total Cost`}</h2>
                        <h2 className="mb-0">{constants.CURRENCY} {items.total_vehicle_cost}</h2>
                      </div>
                      <div className="p-2">
                        <h2 className="mb-0">{`Total Profit`}</h2>
                        <h2 className="mb-0">{constants.CURRENCY} {items.total_profit}</h2>
                      </div>
                    </div>
                  </Col>
                </Row>
                <table className="table table-responsive align-items-center table-flush">
                  {
                    items.data &&
                    Object.keys(items.data).forEach((key, index) => {
                      if (index === 0) {
                        return <thead className="thead-light" key={key}>
                          <tr>
                            <th scope="col">{`Office`}</th>
                            <th scope="col">{`Vehicle`}</th>
                            <th scope="col">{`Stock No`}</th>
                            <th scope="col">{`Rego`}</th>
                            <th scope="col">{`Total Purchase Cost`}</th>
                            <th scope="col">{`Bond`}</th>
                            <th scope="col">{`Sold Price`}</th>
                            <th scope="col">{`Profit`}</th>
                          </tr>
                        </thead>
                      }
                      if (items.data[key].data) {
                        return <tbody key={key}>
                          {items.data[key].data.length > 0 &&
                            items.data[key].data.map((deal, index2) => {
                              return <tr key={index2}>
                                <td>{key}</td>
                                <td>{deal.vehicle}</td>
                                <td>{deal.stock_no}</td>
                                <td>{deal.rego}</td>
                                <td>{`${constants.CURRENCY} ${deal.total_purchased_cost}`}</td>
                                <td>{`${constants.CURRENCY} ${deal.bond}`}</td>
                                <td>{`${constants.CURRENCY} ${deal.sold_price}`}</td>
                                <td>{`${constants.CURRENCY} ${deal.expected_profit}`}</td>
                              </tr>
                            })
                          }
                          <tr className="bold-row">
                            <td>{`Office Total`}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{`${constants.CURRENCY} ${items.data[key].total_vehicle_cost}`}</td>
                            <td>{`${constants.CURRENCY} ${items.data[key].total_bond}`}</td>
                            <td>{`${constants.CURRENCY} ${items.data[key].total_sold}`}</td>
                            <td>{`${constants.CURRENCY} ${items.data[key].total_profit}`}</td>
                          </tr>
                        </tbody>
                      }
                    })
                  }
                </table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}